export const FETCH_POT_ROUNDS = "FETCH_POT_ROUNDS";
export const FETCH_POT_ROUNDS_SUCCESS = "FETCH_POT_ROUNDS_SUCCESS";
export const FETCH_POT_ROUNDS_FAILURE = "FETCH_POT_ROUNDS_FAILURE";

export const FETCH_POT_ENTRIES = "FETCH_POT_ENTRIES";
export const FETCH_POT_ENTRIES_SUCCESS = "FETCH_POT_ENTRIES_SUCCESS";
export const FETCH_POT_ENTRIES_FAILURE = "FETCH_POT_ENTRIES_FAILURE";

export const COMPLETE_POT_ENTRY = "COMPLETE_POT_ENTRY";
export const COMPLETE_POT_ENTRY_SUCCESS = "COMPLETE_POT_ENTRY_SUCCESS";
export const COMPLETE_POT_ENTRY_FAILURE = "COMPLETE_POT_ENTRY_FAILURE";

export const SET_CURRENT_POT = "SET_CURRENT_POT";

export const CREATE_POT_ENTRY = 'CREATE_POT_ENTRY';
export const CREATE_POT_ENTRY_SUCCESS = 'CREATE_POT_ENTRY_SUCCESS';
export const CREATE_POT_ENTRY_FAILURE = 'CREATE_POT_ENTRY_FAILURE';

export const FETCH_POT_LEADERBOARDS = "FETCH_POT_LEADERBOARDS";
export const FETCH_POT_LEADERBOARDS_SUCCESS = "FETCH_POT_LEADERBOARDS_SUCCESS";
export const FETCH_POT_LEADERBOARDS_FAILURE = "FETCH_POT_LEADERBOARDS_FAILURE";

export const FETCH_COMPLETED_POT_ROUNDS = "FETCH_COMPLETED_POT_ROUNDS";
export const FETCH_COMPLETED_POT_ROUNDS_SUCCESS = "FETCH_COMPLETED_POT_ROUNDS_SUCCESS";
export const FETCH_COMPLETED_POT_ROUNDS_FAILURE = "FETCH_COMPLETED_POT_ROUNDS_FAILURE";

export const FETCH_ACTIVE_ROUND = 'FETCH_ACTIVE_ROUND';
export const FETCH_ACTIVE_ROUND_SUCCESS = 'FETCH_ACTIVE_ROUND_SUCCESS';
export const FETCH_ACTIVE_ROUND_FAILURE = 'FETCH_ACTIVE_ROUND_FAILURE';

export const FETCH_NEXT_ROUND = 'FETCH_NEXT_ROUND';
export const FETCH_NEXT_ROUND_SUCCESS = 'FETCH_NEXT_ROUND_SUCCESS';
export const FETCH_NEXT_ROUND_FAILURE = 'FETCH_NEXT_ROUND_FAILURE';